import AlertIcon from '@assets/icons/alert.svg';
import i18n from '@/utils/i18n';
import React from 'react';
import { OrderGuideRightAction } from './order-guide-right-action';
import { TrackingData } from '@/utils/analytics/base-reporter';
import { useTheme } from '@/contexts/theme-context';

interface Props {
  isEssential?: boolean;
  onPress: () => void;
  trackingData?: TrackingData;
}

export const EssentialItemRightAction: React.FC<Props> = ({
  isEssential,
  onPress,
  trackingData,
}) => {
  const theme = useTheme();

  return (
    <OrderGuideRightAction
      backgroundColor={theme.colors.warning}
      Icon={AlertIcon}
      iconProps={{
        stroke: theme.colors.primary,
      }}
      onPress={onPress}
      text={
        isEssential
          ? i18n.t('unmark_as_essential')
          : i18n.t('mark_as_essential')
      }
      trackingData={trackingData ?? null}
    />
  );
};
